export default __webpack_public_path__ + "static/media/_verified-icon.34295c25.svg";